import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LocaleFormat } from '../models';

import { ErrorService } from '@/app/core/errors/error.service';
import { SimpleRdoHttpService } from '@/app/core/http/simple-rdo-http.service';
import { retryBeforeThrow } from '@/app/core/utils/retry-before-throw';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '@/app/core/authentication/authentication.service';

@Injectable()
export class LocaleFormatsService {
  constructor(
    private rdoHttp: SimpleRdoHttpService,
    private errorService: ErrorService,
    private authenticationService: AuthenticationService
  ) {}

  public getLocaleFormats = (): Observable<Array<LocaleFormat>> => {
    let result: Observable<Array<LocaleFormat>> = null;

    result = this.rdoHttp
      .clone()
      .disableRoutingAbort()
      .get('/filter/locale-formats')
      .pipe(
        retryBeforeThrow({ label: 'LocaleFormatsService.getLocaleFormats' }),
        map((r) => r as Array<LocaleFormat>),

        catchError((err) => {
          this.errorService.logSentryError(
            err,
            'LocaleFormatsService.getLocaleFormats failed:'
          );
          return throwError(err);
        })
      );

    return result;
  };
}
